// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

// The tagged union or sum type for the algebraic type `AttachmentKind`.
export const AttachmentKind = __t.enum("AttachmentKind", {
  Screenshot: __t.unit(),
  Log: __t.unit(),
  SystemInfo: __t.unit(),
  Minidump: __t.unit(),
});
export type AttachmentKind = __Infer<typeof AttachmentKind>;

export const BugReport = __t.object("BugReport", {
  id: __t.u64(),
  reporterIdentity: __t.identity(),
  orgId: __t.string(),
  get status() {
    return BugReportStatus;
  },
  get kind() {
    return ReportKind;
  },
  summary: __t.string(),
  description: __t.string(),
  systemInfo: __t.string(),
  includeScreenshot: __t.bool(),
  includeLog: __t.bool(),
  reporterDisplayName: __t.option(__t.string()),
  reporterEmail: __t.option(__t.string()),
  reporterOrgName: __t.option(__t.string()),
  reporterProjectName: __t.option(__t.string()),
  reporterProjectId: __t.option(__t.string()),
  get priority() {
    return Priority;
  },
  category: __t.option(__t.string()),
  triagedBy: __t.option(__t.identity()),
  triagedAt: __t.option(__t.timestamp()),
  closedReason: __t.option(__t.string()),
  githubRepoOwner: __t.option(__t.string()),
  githubRepoName: __t.option(__t.string()),
  githubIssueNumber: __t.option(__t.u64()),
  githubIssueUrl: __t.option(__t.string()),
  lastSyncedAt: __t.option(__t.timestamp()),
  lastGithubError: __t.option(__t.string()),
  syncAttempts: __t.u32(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  stamp: __t.option(__t.string()),
});
export type BugReport = __Infer<typeof BugReport>;

export const BugReportAttachment = __t.object("BugReportAttachment", {
  id: __t.u64(),
  bugReportId: __t.u64(),
  get kind() {
    return AttachmentKind;
  },
  filename: __t.string(),
  size: __t.u32(),
  uploadedAt: __t.timestamp(),
  blobPath: __t.option(__t.string()),
});
export type BugReportAttachment = __Infer<typeof BugReportAttachment>;

export const BugReportBrokerConfig = __t.object("BugReportBrokerConfig", {
  id: __t.u32(),
  brokerUrl: __t.string(),
  serviceToken: __t.string(),
  stdbHost: __t.string(),
  configuredBy: __t.identity(),
  configuredAt: __t.timestamp(),
});
export type BugReportBrokerConfig = __Infer<typeof BugReportBrokerConfig>;

export const BugReportComment = __t.object("BugReportComment", {
  id: __t.u64(),
  bugReportId: __t.u64(),
  githubCommentId: __t.option(__t.u64()),
  get source() {
    return CommentSource;
  },
  authorIdentity: __t.option(__t.identity()),
  authorDisplayName: __t.string(),
  authorLogin: __t.option(__t.string()),
  body: __t.string(),
  htmlUrl: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  githubCreatedAt: __t.option(__t.string()),
});
export type BugReportComment = __Infer<typeof BugReportComment>;

export const BugReportInternal = __t.object("BugReportInternal", {
  bugReportId: __t.u64(),
  internalNotes: __t.string(),
  lastEditedBy: __t.identity(),
  lastEditedAt: __t.timestamp(),
});
export type BugReportInternal = __Infer<typeof BugReportInternal>;

export const BugReportRepo = __t.object("BugReportRepo", {
  id: __t.u64(),
  orgId: __t.string(),
  repoOwner: __t.string(),
  repoName: __t.string(),
  defaultLabels: __t.string(),
  displayName: __t.string(),
  installVerified: __t.bool(),
  createdBy: __t.identity(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  installationId: __t.u64(),
  availableToAllOrgs: __t.bool(),
  stamp: __t.option(__t.string()),
  sharedAcrossDeployments: __t.bool(),
});
export type BugReportRepo = __Infer<typeof BugReportRepo>;

// The tagged union or sum type for the algebraic type `BugReportRole`.
export const BugReportRole = __t.enum("BugReportRole", {
  User: __t.unit(),
  OrgAdmin: __t.unit(),
  PlatformAdmin: __t.unit(),
});
export type BugReportRole = __Infer<typeof BugReportRole>;

// The tagged union or sum type for the algebraic type `BugReportStatus`.
export const BugReportStatus = __t.enum("BugReportStatus", {
  Open: __t.unit(),
  InProgress: __t.unit(),
  Resolved: __t.unit(),
  Wontfix: __t.unit(),
  Duplicate: __t.unit(),
  Withdrawn: __t.unit(),
});
export type BugReportStatus = __Infer<typeof BugReportStatus>;

export const BugReportUser = __t.object("BugReportUser", {
  identity: __t.identity(),
  orgId: __t.string(),
  get role() {
    return BugReportRole;
  },
  displayName: __t.option(__t.string()),
  email: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  lastSeenAt: __t.timestamp(),
  stamp: __t.option(__t.string()),
});
export type BugReportUser = __Infer<typeof BugReportUser>;

// The tagged union or sum type for the algebraic type `CommentSource`.
export const CommentSource = __t.enum("CommentSource", {
  InModule: __t.unit(),
  GithubMirror: __t.unit(),
});
export type CommentSource = __Infer<typeof CommentSource>;

export const DeploymentIssuer = __t.object("DeploymentIssuer", {
  issuer: __t.string(),
  stamp: __t.string(),
});
export type DeploymentIssuer = __Infer<typeof DeploymentIssuer>;

export const DeploymentRegistry = __t.object("DeploymentRegistry", {
  stamp: __t.string(),
  adminOrgId: __t.string(),
  isHouse: __t.bool(),
  webclientBaseUrl: __t.option(__t.string()),
  githubAppInstallUrl: __t.option(__t.string()),
  crossDeploymentSupport: __t.bool(),
  updatedAt: __t.timestamp(),
  updatedBy: __t.identity(),
});
export type DeploymentRegistry = __Infer<typeof DeploymentRegistry>;

// The tagged union or sum type for the algebraic type `GithubActionKind`.
export const GithubActionKind = __t.enum("GithubActionKind", {
  CreateIssue: __t.unit(),
  PostComment: __t.unit(),
  CloseIssue: __t.unit(),
  ReopenIssue: __t.unit(),
});
export type GithubActionKind = __Infer<typeof GithubActionKind>;

export const GithubActionSchedule = __t.object("GithubActionSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  bugReportId: __t.u64(),
  get kind() {
    return GithubActionKind;
  },
  attempt: __t.u32(),
  commentBody: __t.string(),
  commentAuthorDisplay: __t.string(),
  stateReason: __t.string(),
  labels: __t.string(),
  inModuleCommentId: __t.u64(),
});
export type GithubActionSchedule = __Infer<typeof GithubActionSchedule>;

export const GithubAppConfig = __t.object("GithubAppConfig", {
  id: __t.u64(),
  appId: __t.u64(),
  privateKeyPem: __t.string(),
  webhookSecret: __t.string(),
  configuredBy: __t.identity(),
  configuredAt: __t.timestamp(),
});
export type GithubAppConfig = __Infer<typeof GithubAppConfig>;

export const GithubBugConfig = __t.object("GithubBugConfig", {
  orgId: __t.string(),
  repoOwner: __t.string(),
  repoName: __t.string(),
  defaultLabels: __t.string(),
  updatedAt: __t.timestamp(),
  updatedByIdentity: __t.identity(),
  installationId: __t.u64(),
  stamp: __t.option(__t.string()),
});
export type GithubBugConfig = __Infer<typeof GithubBugConfig>;

export const InstallationTokenCache = __t.object("InstallationTokenCache", {
  installationId: __t.u64(),
  token: __t.string(),
  expiresAtSecs: __t.i64(),
  mintedAt: __t.timestamp(),
});
export type InstallationTokenCache = __Infer<typeof InstallationTokenCache>;

export const ModuleConfig = __t.object("ModuleConfig", {
  id: __t.u64(),
  turbotwinOrgId: __t.string(),
  setBy: __t.identity(),
  setAt: __t.timestamp(),
  webclientBaseUrl: __t.option(__t.string()),
  githubAppInstallUrl: __t.option(__t.string()),
});
export type ModuleConfig = __Infer<typeof ModuleConfig>;

export const PostRestoreMarker = __t.object("PostRestoreMarker", {
  id: __t.u64(),
  ranAt: __t.timestamp(),
  ranBy: __t.identity(),
  rowsStamped: __t.u64(),
});
export type PostRestoreMarker = __Infer<typeof PostRestoreMarker>;

// The tagged union or sum type for the algebraic type `Priority`.
export const Priority = __t.enum("Priority", {
  Unset: __t.unit(),
  Low: __t.unit(),
  Medium: __t.unit(),
  High: __t.unit(),
  Critical: __t.unit(),
});
export type Priority = __Infer<typeof Priority>;

export const ReconcileSchedule = __t.object("ReconcileSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  reportId: __t.u64(),
});
export type ReconcileSchedule = __Infer<typeof ReconcileSchedule>;

// The tagged union or sum type for the algebraic type `ReportKind`.
export const ReportKind = __t.enum("ReportKind", {
  Bug: __t.unit(),
  FeatureRequest: __t.unit(),
  Question: __t.unit(),
  Feedback: __t.unit(),
});
export type ReportKind = __Infer<typeof ReportKind>;

export const ServiceConfig = __t.object("ServiceConfig", {
  id: __t.u64(),
  serviceIdentity: __t.identity(),
  configuredAt: __t.timestamp(),
});
export type ServiceConfig = __Infer<typeof ServiceConfig>;

export const WebhookInbox = __t.object("WebhookInbox", {
  compositeKey: __t.string(),
  source: __t.string(),
  externalId: __t.string(),
  receivedAt: __t.timestamp(),
});
export type WebhookInbox = __Infer<typeof WebhookInbox>;

